export default __webpack_public_path__ + "static/media/016-scales.e5d7c6e8.svg";